import React, { useEffect, useState, useRef, useMemo } from 'react'
import { trans } from '../../../_providers/Translation'

import { useHistory, useLocation, Link, useParams } from 'react-router-dom'
import Api from '../../../_helpers/Api'
import loader from '../../../assets/img/loader.svg'
import Filter from './partials/FilterExpenses'
import style from '../../../assets/css/accounts.css'
import GroupedBarChart from '../../partials/GroupedBarChart'
import { getPaletteColor } from '../../partials/chartTheme'

let timeout

function Expenses() {

    const params = useParams()
    const history = useHistory()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    const [state, setState] = useState({
        loading: true,
        data: {
            dates: [],
            categories: []
        },
        filter: {},
        setFilter: false,
        update: false,
        summary: false,
        allowDetails: true,
    })

    useEffect(() => {
        setState(prev => ({
            ...prev,
            page: searchParams.get('page') || 1,
            filter: {
                ...prev.filter,
                start: searchParams.get('start') || '',
                end: searchParams.get('end') || '',
                employee_id: searchParams.get('employee_id') || '',
                group: searchParams.get('group') || '',
            },
            update: new Date().getTime()
        }))

    }, [location.search])

    useEffect(() => {

        if (state.setFilter) {
            Object.entries(state.filter).map(filter => {
                // if (filter[1]) {
                searchParams.set(filter[0], filter[1])
                // }
            })

            let url = '?' + searchParams.toString()

            history.push(url)
        }

    }, [state.setFilter])

    useEffect(() => {
        if (state.update) {
            loadData()
        }
    }, [state.update])

    const loadData = () => {
        setState(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'accounts/expenses'

        Object.entries(state.filter).map(filter => {
            url += (url.indexOf('?') > -1 ? '&' : '?') + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: res.data,
                    // chart: chart,
                    filter: {
                        ...prev.filter,
                        group: res.data.group,
                        start: res.data.start,
                        end: res.data.end
                    },
                    loading: false,
                    summary: res.data.categories.length === 0 ? true : prev.summary,
                    allowDetails: res.data.categories.length === 0 ? false : true
                }))
            })
    }

    const handleSearch = (key, val, delay = 300) => {

        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
            setFilter: new Date().getTime()
        }))

    }

    const toggleSummaryData = val => {
        setState(prev => ({
            ...prev,
            summary: val
        }))
    }

    const currency = state.data.currency || ''

    const chartLabels = (state.data.dates || []).map(d => d.label)

    const chartSeries = state.summary
        ? [
            {
                name: trans('random.expense'),
                color1: getPaletteColor(0).color1,
                color2: getPaletteColor(0).color2,
                data: (state.data.dates || []).map(d => Number(d.total) || 0),
                valueFormatter: (value) => `${value} ${currency}`,
            },
        ]
        : (state.data.categories || []).map((c, i) => ({
            name: c.name,
            color1: getPaletteColor(i).color1,
            color2: getPaletteColor(i).color2,
            data: (state.data.dates || []).map(d => Number(c.dates[d.date]?.total) || 0),
            valueFormatter: (value) => `${value} ${currency}`,
        }))

    return (
        <>
            <Filter
                allowDetails={state.allowDetails}
                filter={state.filter}
                summary={state.summary}
                handleSearch={handleSearch}
                toggleSummaryData={toggleSummaryData}
            />

            <hr />

            {state.loading
                ?
                <img className="loader" src={loader} />
                :
                <>
                    <div
                        className="chart"
                        style={{
                            background: '#fff',
                            padding: '5px'
                        }}>
                        <div className="head">
                            <ul>
                                {chartSeries.map((s, i) => (
                                    <li
                                        key={'legend-' + i}
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 6,
                                            marginRight: 16,
                                            fontSize: 13,
                                            color: '#64748b',
                                        }}
                                    >
                                        <span
                                            style={{
                                                width: 12,
                                                height: 12,
                                                borderRadius: '50%',
                                                display: 'inline-block',
                                                backgroundImage: `linear-gradient(to bottom, ${s.color1}, ${s.color2})`,
                                            }}
                                        />
                                        {s.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <GroupedBarChart
                            labels={chartLabels}
                            series={chartSeries}
                        />
                    </div>

                    <hr />
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        {trans('tables.category')}
                                    </th>
                                    {state.data.dates.map((d, i) =>
                                        <th key={'th-' + i} className="right">
                                            {d.label}
                                        </th>
                                    )}
                                    <th className="right">
                                        {trans('tables.total')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.categories.map(c =>
                                    <tr key={'c-' + c.id}>
                                        <td>
                                            {c.name}
                                        </td>
                                        {state.data.dates.map((d, i) =>
                                            <td key={'td-' + i} className="right">
                                                {c.dates[d.date].total_formatted}
                                            </td>
                                        )}
                                        <td className="right">
                                            {c.total_formatted}
                                        </td>
                                    </tr>
                                )}

                                <tr>
                                    <td>
                                        {trans('tables.total')}
                                    </td>
                                    {state.data.dates.map((d, i) =>
                                        <td key={'totals-' + i} className="right">
                                            {d.total_formatted}
                                        </td>
                                    )}
                                    <td className="right">
                                        {state.data.total_formatted}
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        {trans('tables.total_vat')}
                                    </td>
                                    {state.data.dates.map((d, i) =>
                                        <td key={'totals_vat-' + i} className="right">
                                            {d.total_vat_formatted}
                                        </td>
                                    )}
                                    <td className="right">
                                        {state.data.total_vat_formatted}
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </>
            }

        </>
    )
}

export default Expenses